import Swiper, { Navigation, EffectCards } from 'swiper';

function achievementsChoicer() {
  const entity = document.querySelectorAll('.js-achievements-choicer');
  const link = document.getElementById('achievements-downloader');
  if (!entity || !link) return;

  const sliders = [];

  entity.forEach((elem) => {
    const nextButton = elem.querySelector('.swiper-button-next');
    const prevButton = elem.querySelector('.swiper-button-prev');
    const swiper = new Swiper(elem, {
      modules: [EffectCards, Navigation],
      effect: 'cards',
      cardsEffect: {
        rotate: true,
      },
      grabCursor: true,
      initialSlide: 0,
      speed: 500,
      loop: true,
      mousewheel: {
        invert: false,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        init: function () {
          this.el.classList.remove('swiper');
          this.slides.forEach((slide) => {
            const img = slide.querySelector('img');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = 1274;
            canvas.height = 1802;
            const name = img.dataset.name;
            const color = String(img.dataset.color) || 'transparent';
            const image = new Image();
            image.crossOrigin = 'Anonymous';
            image.src = img?.src;
            image.onload = function () {
              ctx.drawImage(image, 0, 0);
              ctx.font = 'bold 65px Roboto';
              ctx.fillStyle = color;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              ctx.fillText(name, canvas.width / 2, canvas.height / 2 + 40);
              img.dataset.image = canvas.toDataURL('image/jpg');
              if (slide.classList.contains('swiper-slide-active')) {
                link.download = `${name}.jpg`;
                link.href = img.dataset.image;
              }
            };
          });
        },
        activeIndexChange: function () {
          const activeSlide = this.slides[this.activeIndex];
          link.download = activeSlide?.querySelector('img')?.dataset?.name;
          link.href = activeSlide?.querySelector('img')?.dataset?.image;
        },
      },
    });

    return sliders.push(swiper) // eslint-disable-line
  });

  return { // eslint-disable-line
    sliders,
  };
}

export default achievementsChoicer;
